import type { SVGProps } from 'react';
export const SvgPrefixLink = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12.492 14.583h1.258A4.597 4.597 0 0 0 18.333 10a4.597 4.597 0 0 0-4.583-4.583h-1.258M7.5 5.417H6.25A4.59 4.59 0 0 0 1.667 10a4.597 4.597 0 0 0 4.583 4.583H7.5M6.667 10h6.666"
		/>
	</svg>
);
